import { createStore } from "vuex";
import servicesModule from "./../../store/modules/services.vuex";

const storeConfig = {
  modules: {
	services: servicesModule,
  },
};

export default createStore(storeConfig);